import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import Balancer from 'react-wrap-balancer';

import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';
import styled from 'styled-components';

import ScrollReveal from '@components/common/ScrollReveal';
import { Container } from '@components/parts/Container';

import { TDIs } from '@customTypes/TDI';

type Props = {
  tdis: TDIs;
};

const Wrapper = styled.div`
  margin-top: 50px;
  margin-bottom: 90px;

  width: 100%;

  @media (min-width: 992px) {
    margin-top: 70px;
    margin-bottom: 160px;
  }
  border-top: 1px solid #e3e5ea;
  .item {
    border-bottom: 1px solid #e3e5ea;

    .title {
      padding: 25px 0;
      cursor: pointer;
      color: #2e3035;
      display: flex;
      flex-direction: row;
      align-items: center;
      h6 {
        font-weight: 500;
        flex: 1;
      }
      svg {
        transform: rotate(0deg);
        transition: all 0.3s;
        @media (min-width: 992px) {
          width: 24px;
          height: 24px;
        }
      }
    }
    .description {
      display: none;
      margin-bottom: 1.5em;
      line-height: 30px;
      color: #62656a;
      ul,
      ol {
        margin-block: 0;
        margin-inline: 0;
        padding-inline-start: 2em;
      }
    }
    &.opened {
      .title {
        svg {
          transform: rotate(180deg);
        }
      }
      .description {
        display: block;
      }
    }
  }
`;

const Chevron = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1040_11283)">
      <path d="M5 7.5L10 12.5L15 7.5" stroke="#C7CAD0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_1040_11283">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const StyledContainer = styled(Container)`
  .container {
    width: 100%;
    max-width: 970px;
    @media (min-width: 1200px) {
      max-width: 1080px;
    }
  }
`;

export const FAQ: React.FC<Props> = (props) => {
  const { tdis } = props;
  const [openedIdx, setOpenedIdx] = useState<null | number>(null);
  return (
    <StyledContainer>
      <ScrollReveal>
        <Wrapper>
          {tdis.map((tdi, idx) => (
            <div key={idx} className={`${openedIdx === idx ? 'opened ' : ''}item`}>
              <div className="title" onClick={() => setOpenedIdx(openedIdx === idx ? null : idx)}>
                <h6>
                  <Balancer>{tdi.title}</Balancer>
                </h6>
                <Chevron />
              </div>
              <div className="description">
                <Balancer>
                  <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
                    {tdi.description || ''}
                  </ReactMarkdown>
                </Balancer>
              </div>
            </div>
          ))}
        </Wrapper>
      </ScrollReveal>
    </StyledContainer>
  );
};
